"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addTimeToDate = addTimeToDate;
exports.splitTimeString = splitTimeString;
var _moment = _interopRequireDefault(require("moment"));
/**
 * @description Splits time string and returns array of hours and minutes
 * @param {string} time
 * @returns Array
 */
function splitTimeString(time) {
  return time.split(':');
}

/**
 * @description Adds time to date
 * @param {string} date
 * @param {string} format
 * @param {string} hours
 * @param {string} minutes
 * @returns number
 */
function addTimeToDate(date, format, hours, minutes) {
  return _moment["default"].utc(date, format).add(hours, 'hours').add(minutes, 'minutes').valueOf();
}